exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul.steps li {\n    padding: 0 10px;\n}\n.product-detail h1 {\n    font-size: 35px;\n    line-height: 32px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-invoices/product-detail/product-detail.component.css
// module id = ../../../../../src/app/mnt-invoices/product-detail/product-detail.component.css
// module chunks = common